import { api } from './api';
import { User, UserProfile } from '../types';

export interface ProfileData {
  name?: string;
  email?: string;
  phone?: string;
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  postalCode?: string;
  dateOfBirth?: string;
  bio?: string;
  licenseNumber?: string;
  specialization?: string;
}

export interface PasswordChangeData {
  currentPassword: string;
  newPassword: string;
}

export interface ProfileResponse {
  success: boolean;
  data: {
    user: User & {
      profile: UserProfile;
    };
  };
}

export const getProfile = async (): Promise<ProfileResponse> => {
  const response = await api.get('/auth/profile');
  return response.data;
};

export const updateProfile = async (data: ProfileData): Promise<{ success: boolean; message: string }> => {
  const response = await api.put('/auth/profile', data);
  return response.data;
};

export const uploadAvatar = async (file: File): Promise<{ success: boolean; message: string; data: { avatarUrl: string } }> => {
  const formData = new FormData();
  formData.append('avatar', file);

  // Don't set Content-Type header - let the browser set it with the correct boundary
  const response = await api.post('/auth/profile/avatar', formData);
  return response.data;
};

export const changePassword = async (data: PasswordChangeData): Promise<{ success: boolean; message: string }> => {
  const response = await api.put('/auth/profile/password', data);
  return response.data;
};




